// const password = 'dan123'
// const url = new URL(window.location.href);
// const params = new URLSearchParams(url.search);
// const connectionToken = params.get('connectionToken');
// if (connectionToken && connectionToken === password) window.localStorage.setItem('connectionToken', connectionToken);
// if (connectionToken != password  && window.localStorage.getItem('connectionToken') != password ){
//     throw new Error('encorrect password');
// }
// http://localhost:8080/?connectionToken=dan123

const url = new URL(window.location.href);
const params = new URLSearchParams(url.search);
const auth_token = params.get('auth_token');
if (auth_token) window.localStorage.setItem('user_token', auth_token);

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import globalMixin from './globalMixin'
import $bus from './eventbus';
import directives from "./directives/";

import VueClickAway from "vue3-click-away";
// import vClickOutside from 'v-click-outside'

import './css/general.scss'
import './css/multi.scss'
import './css/styles.scss'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'


window.api_url = process.env.NODE_ENV === 'development' ? 'https://dev.m-shakuf.co.il/api/' : 'https://m-shakuf.co.il/api/'; 

const app = createApp({
    extends: App
}).use(VueClickAway).use(store).use(router)

app.mixin(globalMixin);
directives(app);

import axios from 'axios'
import VueAxios from 'vue-axios'
app.use(VueAxios, axios)

import Vue3Signature from "vue3-signature"
app.use(Vue3Signature);

import Tooltip from 'primevue/tooltip';
app.directive('tooltip', Tooltip);

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
app.use(VueSweetalert2);
import wzselect from '@/components/wzselect.vue';
app.component('wzselect', wzselect)

import Popup from './components/popup.vue'
app.component('Popup', Popup);

// import Banner from "./components/banner.vue";
// app.component("Banner", Banner);


app.config.globalProperties.$bus = $bus;


app.use((app) => {
    let Vue = {
        mixin: (m) => {
            app.mixin(m);
        },
        prototype: {}
    };

    Object.keys(Vue.prototype).forEach((key) => {
        app.config.globalProperties[key] = Vue.prototype[key]
    });
    

  })


app.mount('#app');